import { render, staticRenderFns } from "./DocListMenu.vue?vue&type=template&id=305e3fb3&scoped=true"
import script from "./DocListMenu.vue?vue&type=script&lang=js"
export * from "./DocListMenu.vue?vue&type=script&lang=js"
import style0 from "./DocListMenu.vue?vue&type=style&index=0&id=305e3fb3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305e3fb3",
  null
  
)

export default component.exports